import { FormSelect } from '@systemeio/ui'
import { useClassicCoursesListAll } from 'modules/courses/courses/classic-course/hooks/use-classic-courses-list-all'
import { CourseId } from 'modules/courses/courses/types/course-interface'
import ItemSteps from 'modules/stores/store/components/item-steps'
import React, { FC } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export interface ClassicCourseProps {
  courseId?: CourseId
  courseSelectorError?: string
  onChangeCourse: (courseId?: number) => void
}

export const ClassicCourse: FC<ClassicCourseProps> = ({
  courseId,
  courseSelectorError,
  onChangeCourse,
}) => {
  const { t } = useLocoTranslation()

  const { coursesData } = useClassicCoursesListAll()

  return (
    <ItemSteps
      steps={[
        {
          key: 'course select',
          title: t('dashboard.store.item.e_course.select_course.title'),
          element: (
            <FormSelect
              placeholder={t('dashboard.store.item.e_course.select_course.placeholder')}
              value={courseId}
              data={coursesData}
              onChange={onChangeCourse}
              error={courseSelectorError}
              withoutCloseIcon
            />
          ),
        },
      ]}
    />
  )
}
